module.exports = __webpack_public_path__ + "static/media/level05.38bedbf9.svg";